import { Box, LinearProgress, Paper, Typography } from '@mui/material';

interface MetricCardProps {
  color: string;
  icon: React.ReactNode;
  value: number | string;
  label: string;
  progressValue?: number;
  progressLabel?: string;
  bottomLabel?: string;
  bottomIcon?: React.ReactNode;
}

const MetricCard: React.FC<MetricCardProps> = ({
  color,
  icon,
  value,
  label,
  progressValue,
  progressLabel,
  bottomLabel,
  bottomIcon,
}) => (
  <Paper
    sx={{
      p: 2,
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
      height: '100%',
      width: '100%'
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: progressValue ? 2 : 0,
      }}
    >
      <Box>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            color,
            fontSize: { xs: '1.5rem', sm: '2rem' },
          }}
        >
          {value}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
        >
          {label}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>{icon}</Box>
    </Box>

    {progressValue !== undefined && (
      <Box sx={{ mt: 'auto' }}>
        <LinearProgress
          variant="determinate"
          value={progressValue}
          sx={{
            height: 6,
            borderRadius: 3,
            mb: 1,
            backgroundColor: `${color}33`,
            '& .MuiLinearProgress-bar': { backgroundColor: color },
          }}
        />
        <Typography variant="caption" color="text.secondary">
          {progressLabel}
        </Typography>
      </Box>
    )}

    {bottomLabel && (
      <Box sx={{ display: 'flex', alignItems: 'center', mt: 'auto' }}>
        {bottomIcon}
        <Typography variant="caption" color="success.main">
          {bottomLabel}
        </Typography>
      </Box>
    )}
  </Paper>
);


export default MetricCard;
